<template>
    <div class="automation-listing-table-actions">
        <CompassMenu
            ref="refMenuActions"
            trigger="click"
            customClass="automation-listing-table-actions__menu"
        >
            <CompassIconButton icon="action" />
            <template #dropdown>
                <CompassMenuItem
                    :label="$t.__('common.actions.rename')"
                    data-bot="automation-listing__submenu--rename"
                    @click="handleRename"
                />
                <CompassMenuItem
                    :label="$t.__('common.actions.edit')"
                    :disabled="!canEditAutomation"
                    data-bot="automation-listing__submenu--update"
                    @click="handleEdit"
                />
                <CompassMenuItem
                    :label="$t.__('common.actions.duplicate')"
                    data-bot="automation-listing__submenu--duplicate"
                    @click="handleDuplicate"
                />
                <CompassMenuItem
                    :label="$t.__('common.actions.delete')"
                    data-bot="automation-listing__submenu--delete"
                    @click="handleDelete"
                />
            </template>
        </CompassMenu>
    </div>
</template>

<script>
import { duplicateAutomation } from 'api/automation/automationService.js';
import Feature from 'Services/Feature';

import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

export default {
    props: {
        automation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapStateSystem(['errorsHandler']),
        isWizardAutomation() {
            return this.automation?.metadata?.wizard === true;
        },
        hasAutomationBuilderFeature() {
            return Feature.isEnabled('automations-builder');
        },
        canAccessBuilder() {
            if (this.isWizardAutomation) {
                return false;
            }
            return this.hasAutomationBuilderFeature;
        },
        canEditAutomation() {
            return this.isWizardAutomation || this.canAccessBuilder;
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        handleEdit() {
            if (this.isWizardAutomation) {
                this.handleEditWizardAutomation();
            } else {
                this.$router.push({
                    name: 'automations.flow.builder',
                    params: { id: this.automation.id },
                });
            }
        },
        handleEditWizardAutomation() {
            this.$emit('edit-wizard-automation', this.automation);
        },
        handleDuplicate() {
            duplicateAutomation(this.automation.id, { 'metadata': this.automation?.metadata || null })
                .then((response) => {
                    if (this.canAccessBuilder) {
                        this.$router.push({
                            name: 'automations.flow.builder',
                            params: { id: response.data.id },
                        });
                    } else {
                        this.$pushToast({
                            type: 'success',
                            close: true,
                            text: this.$t.__('automation.common.success.duplicated'),
                        });
                        this.$emit('automation-duplicated');
                    }
                })
                .catch((error) => {
                    this.errorsHandler.handleError(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('common.labels.toast.error'),
                    });
                });
        },
        handleDelete() {
            this.open({
                key: 'automationDeleteDialog',
                props: {
                    automation: this.automation,
                },
            });
        },
        handleRename() {
            this.open({
                key: 'automationRenameDialog',
                props: {
                    automation: this.automation,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.compass-menu__dropdown__container.automation-listing-table-actions__menu {
    z-index: 3;
}
</style>
